module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-ja.afb042c2.mp4";